import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TranslateConfigService {
  public path: string = '';
  constructor() {}
  setPath(path: string): void {
    this.path = path;
  }

  getPath() {
    return this.path;
  }
}
